@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.admin.staff

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.admin.AdminDto
import com.narbase.letsgo.web.dto.admin.DynamicRoleDto
import com.narbase.letsgo.web.dto.admin.ExtendedAdminDto


object GetAdminsEndpoint : EndPoint<GetAdminsEndpoint.Request, GetAdminsEndpoint.Response>() {
    class Request(
            val pageNo: Int,
            val pageSize: Int,
            val searchTerm: String?,
    )

    class Response(
            val list: Array<ExtendedAdminDto>,
            val total: Int
    )
}

